
import {map} from 'rxjs/operators';
import {ViewChild, ElementRef, Component, Input, Output, EventEmitter} from '@angular/core'
import { OnInit } from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {KeyValue} from '../../shared/key-value';

import {AuthorizationService} from '../../shared/authorization.service';

@Component({
  selector: 'app-run-submit-popup',
  templateUrl: './run-submit-popup.component.html',
  styleUrls: ['./run-submit-popup.component.css']
})
export class RunSubmitPopupComponent{
selected_decision_set: any = { security: {}, loan: {}, treasury: {}, deposit: {}, team: {} };
is_submited:boolean;
is_submited_what_if:boolean;
submited:boolean;
  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService, private KeyValueService: KeyValue) {
      this.is_submited=false;
      this.is_submited_what_if=false;
  }

  check_submited_decisions() {
    // this.selected_decision_set.is_submited = true
    this.authService.post(KeyValue.submiteddecisionStatusPath, { decision_set: this.selected_decision_set}).pipe(
      map(res => res)).subscribe(
      data => {
        if (data.status == 200) {
          if(data.is_submited == null)
          {
            this.is_submited=false;
            this.is_submited_what_if=false;
            let value={submit: this.is_submited,what_if: this.is_submited_what_if}
            this.KeyValueService.decision_sets_is_submited_update(value)
          } else {
          this.submited = data.submited;
          this.is_submited=data.is_submited;
          this.is_submited_what_if=data.is_submited
          let value={submit: this.is_submited,what_if: this.is_submited_what_if}
          this.KeyValueService.decision_sets_is_submited_update(value)
          }
          this.KeyValueService.decision_sets_update(data);
          if (this.submited) {
            KeyValue.flash_msg_update({ msg: 'Decisions have been finalized. They can no longer be changed for this quarter.', type: 'success_messages' });
          } else {
            KeyValue.flash_msg_update({ msg: 'Decision set already submitted once.', type: 'error_messages' });
          }
        } else {
          KeyValue.flash_msg_update({ msg: data.errors, type: 'error_messages' })
        }
      },
      error => {
        console.log('in... signin success' + error)
      }
      );
  }




  submitForm() {
      this.check_submited_decisions()
  }

  ngOnInit() {
    // subscription for current decision update
    this.KeyValueService.current_decision_set$.subscribe(
      data => {
        if (data != undefined){
          this.selected_decision_set = data;
        }
      });

  }


}
